import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
/** @jsx jsx */

import { Fragment } from 'react';
import { jsx } from '@emotion/core';
import { DEFAULT_I18N_PROPS_SKIP_LINKS, PAGE_LAYOUT_CONTAINER_SELECTOR } from '../../common/constants';
import { SidebarResizeController, SkipLinksController } from '../../controllers';
import { SkipLinkWrapper } from '../skip-links';
import { gridStyles } from './styles';

var pageLayoutSelector = _defineProperty({}, PAGE_LAYOUT_CONTAINER_SELECTOR, true);

var PageLayout = function PageLayout(_ref) {
  var _ref$skipLinksLabel = _ref.skipLinksLabel,
      skipLinksLabel = _ref$skipLinksLabel === void 0 ? DEFAULT_I18N_PROPS_SKIP_LINKS : _ref$skipLinksLabel,
      children = _ref.children,
      testId = _ref.testId,
      onLeftSidebarExpand = _ref.onLeftSidebarExpand,
      onLeftSidebarCollapse = _ref.onLeftSidebarCollapse;
  return jsx(Fragment, null, jsx(SkipLinksController, null, jsx(SkipLinkWrapper, {
    skipLinksLabel: skipLinksLabel
  }), jsx("div", _extends({}, pageLayoutSelector, {
    "data-testid": testId,
    css: gridStyles,
    tabIndex: -1
  }), jsx(SidebarResizeController, {
    onLeftSidebarCollapse: onLeftSidebarCollapse,
    onLeftSidebarExpand: onLeftSidebarExpand
  }, children))));
};

export default PageLayout;